import { useState } from 'react';
import styles from './HomeEquityCard.module.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../hooks/useAuth';
import { IHomeEquityListItem } from '../../types';
import { Notify } from '../../../../components/Notify';
import { ShareButton } from '../../../../components/ShareButtons';
import * as routes from '../../../../constants/Routes';

interface HomeEquityCardProps {
  homeEquity: IHomeEquityListItem;
}

export function HomeEquityCard({ homeEquity }: HomeEquityCardProps) {
  const { client, player } = useAuth();
  const navigate = useNavigate();
  const [shareOpen, setShareOpen] = useState(false);

  const coverImage = homeEquity.medias?.images?.[0];
  const { internalName, financialPartner } = homeEquity.settings;

  const shareUrl =
    homeEquity.shareUrl ??
    `${window.location.origin}${routes.HOME_EQUITY}/${homeEquity.id}/${player?.id ?? ''}`;

  const actionObj = { id: homeEquity.id, shareUrl };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      Notify('Link copiado com sucesso', 'success');
    } catch {
      Notify('Erro ao copiar link', 'error');
    }
  };

  return (
    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner}>
          {coverImage ? (
            <>
              <img src={coverImage} alt={internalName} />
              <div className={styles.cardBannerOverlay} />
            </>
          ) : (
            <div className={styles.noImageFallback}>
              <i className="material-icons-outlined">home</i>
              <span>Home Equity</span>
            </div>
          )}
          {financialPartner && (
            <div
              className={styles.partnerBadge}
              style={{ background: client?.primaryColor }}
            >
              {financialPartner}
            </div>
          )}
        </div>

        <div className={styles.cardBody}>
          <span className={styles.cardTitle}>{internalName}</span>
        </div>

        <div className={styles.clipboard}>
          <input
            className="px-4"
            placeholder="Link de compartilhamento"
            value={shareUrl}
            disabled
            type="text"
          />
          <button onClick={handleCopy} className="p-4">
            <i className="material-icons-outlined">content_copy</i>
          </button>
        </div>

        <div className={styles.cardAction}>
          <button
            onClick={() =>
              navigate(`${routes.HOME_EQUITY_DETAILS}/${homeEquity.id}`, {
                state: { shareUrl },
              })
            }
          >
            <i className="material-icons-outlined mx-2">add</i>
            <span>Mais detalhes</span>
          </button>
          <button className={styles.cta} onClick={() => setShareOpen(true)}>
            <i className="material-icons-outlined mx-2">share</i>
            <span>Indique agora</span>
          </button>
        </div>

        {shareOpen && (
          <div className={styles.revealWrapper}>
            <div className={`${styles.reveal} ${styles.open}`}>
              <div className={`${styles.revealContent} p-4`}>
                <div className={styles.topReveal}>
                  <span style={{ color: client?.primaryColor }}>
                    Compartilhar
                  </span>
                  <button onClick={() => setShareOpen(false)}>
                    <i className="material-icons-outlined">close</i>
                  </button>
                </div>
                <div className="container">
                  <span>Compartilhe rapidamente via</span>
                  <div className="my-3">
                    <ShareButton action={actionObj} />
                  </div>
                  <span>Ou copie o link</span>
                  <div className="mt-3">
                    <div className={styles.clipboard}>
                      <input
                        className="px-4"
                        placeholder="Link de compartilhamento"
                        value={shareUrl}
                        disabled
                        type="text"
                      />
                      <button onClick={handleCopy} className="p-4">
                        <i className="material-icons-outlined">content_copy</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
